import React from "react";
import {
	secondsToHHMM,
	addDecimalPoints,
	defineFlightCabin
} from "../shared/utils";

const FlightResume = props => {
	const showMilesTotalPerAdult = () => {
		const milesObj = props.flightdata.pricing.miles;

		if (milesObj !== null) {
			try {
				return milesObj.adult.miles;
			} catch (e) {
				console.log("erro obtendo milhas por adulto");
			}
		}
	};

	if (props.flightdata === undefined) return null;

	return (
		<div className="flight-item-details">
			<ul className="list-inline">
				<li className="small">
					<strong>Duração total: </strong>
					{secondsToHHMM(props.flightdata.duration * 60)}
				</li>
				{props.flightdata.pricing.miles && (
					<li className="small">
						<strong>Qtd. de milhas: </strong>
						{addDecimalPoints(showMilesTotalPerAdult())} (por adulto)
					</li>
				)}
				{props.flightdata.stops === "direct" && (
					<li className="small">
						<strong>Classe deste trecho: </strong>
						{defineFlightCabin(
							props.flightdata.trips[0],
							props.flightdata.airline,
							props.flightdata.pricing.mmBestPriceAt === "ota"
						)}
					</li>
				)}
				{props.flightdata.stops === "direct" &&
					props.flightdata.trips[0].carrier !== "" && (
						<li className="small">
							<strong>Operado por:</strong> {props.flightdata.trips[0].carrier}
						</li>
					)}
			</ul>
		</div>
	);
};

export default FlightResume;
